import { useRoutes } from "react-router-dom";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";

const routes = [
  { path: "/*", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/reset-password", element: <ResetPassword /> },
];

const SessionRouter = () => useRoutes(routes);
export default SessionRouter;
